export const FORM_NAME = "account";
export const STATE_NAME = "accountScreen";
